import React from 'react';

import {OutlinePrimaryLink} from '../components/OutlinePrimaryLink';
import {PageMenu} from '../components/PageMenu';
import {SwiperCarousel} from '../components/SwiperCarousel';

type SpaceCard = {
  img: string;
  tag: string;
  paragraphs: string[];
};

const SPACE_CARDS: SpaceCard[] = [
  {
    img: '/assets/acm/spring.jpg',
    tag: 'スペース春',
    paragraphs: [
      '春をイメージしピンク色を基調としたスペース。',
      '面積約６１㎡、席数は３０席程度。',
    ],
  },
  {
    img: '/assets/acm/summer.jpg',
    tag: 'スペース夏',
    paragraphs: [
      '夏をイメージし水色を基調としたスペース。',
      '面積約３６㎡、席数は１８席程度。',
    ],
  },
  {
    img: '/assets/acm/autumn.jpg',
    tag: 'スペース秋',
    paragraphs: [
      '秋をイメージしオレンジ色を基調としたスペース。',
      '面積約２５㎡、席数は１５席程度。',
    ],
  },
  {
    img: '/assets/acm/spring_summer.jpg',
    tag: 'スペース春+夏',
    paragraphs: ['スペース春と夏をつなげて広めの会場スペースとして。'],
  },
  {
    img: '/assets/acm/spring_autumn.jpg',
    tag: 'スペース春+秋',
    paragraphs: [
      'スペース春と秋をつなげて演台から全体が見渡せるセミナー会場など可能。',
    ],
  },
  {
    img: '/assets/acm/spring_summer_autumn.png',
    tag: 'スペース春+夏+秋',
    paragraphs: [
      'スペースすべてをつなげた、ACミハラ最大会場スペースとしてご利用ください。',
    ],
  },
];

type Facility = {img: string; name: string; description: string};

const FACILITIES: Facility[] = [
  {
    img: '/assets/illustration/21.png',
    name: '受付代行',
    description:
      'ACミハラご利用の場合、会場受付、参加費徴収、領収書発行などを代行いたします。',
  },
  {
    img: '/assets/illustration/22.png',
    name: '資料準備',
    description:
      'ACミハラご利用の場合、資料の印刷、コピーなど対応させて頂きます。',
  },
  {
    img: '/assets/illustration/23.png',
    name: '昼食・オードブル',
    description:
      'ACミハラご利用の場合、昼食やオードブルの注文を代行いたします。',
  },
  {
    img: '/assets/illustration/24.png',
    name: 'アンケート代行',
    description:
      'イベントやセミナー参加者の方へのアンケート依頼を代行いたします。',
  },
  {
    img: '/assets/illustration/25.png',
    name: '集客支援',
    description: 'LP作成、メルマガ配信などにより集客を代行させていただきます。',
  },
];

export const FacilityPage: React.FC = () => (
  <main>
    <PageMenu active="/facility" />

    {/* ヒーロー */}
    <section className="pb-20 pt-16 text-center">
      <div className="mx-auto max-w-[960px] px-4">
        <h1 className="mb-9 mt-8 text-3xl font-light tracking-[2.1px] text-neutral-900">
          料金・施設
        </h1>
        <p className="text-sm font-light text-neutral-900">
          オープン記念としてお得な料金でご利用いただけます。
        </p>
        <div className="mt-12">
          <OutlinePrimaryLink href="#price" size="md" className="mx-1 w-60">
            <span>料金</span>
          </OutlinePrimaryLink>
          <OutlinePrimaryLink href="#floor" size="md" className="mx-1 w-60">
            <span>フロアガイド</span>
          </OutlinePrimaryLink>
          <OutlinePrimaryLink href="#facility" size="md" className="mx-1 w-60">
            <span>施設・サービス</span>
          </OutlinePrimaryLink>
          <OutlinePrimaryLink href="#access" size="md" className="mx-1 w-60">
            <span>アクセス</span>
          </OutlinePrimaryLink>
        </div>
      </div>
    </section>

    {/* 料金 */}
    <section id="price" className="border-t border-neutral-100 pb-20 pt-16">
      <div className="text-center">
        <h2 className="mb-10 inline-flex border-b-2 border-primary pb-1 text-base font-semibold tracking-[1.2px] text-primary">
          料金
        </h2>
      </div>
      <div className="mx-auto mb-8 max-w-[840px] px-4 text-center text-sm font-light text-neutral-900">
        <p>アカウント登録無料、月額費無料。</p>
        <p>無料イベントの場合、手数料無料。</p>
        <p>
          有料イベントの場合、手数料は チケット売上✕４.0%＋30円 ／チケット
          のみ。
        </p>
        <p>ACミハラスペースの利用料は下記のとおり。</p>
      </div>

      <div className="mx-auto max-w-[1110px] px-4">
        <div className="flex justify-around">
          <div className="pt-14">
            <p className="mb-3 text-center text-sm font-light text-neutral-900">
              イベントスペースとして利用
            </p>
            <div className="mb-5 flex w-[440px] flex-col items-center border border-neutral-100 px-[60px] py-10">
              <dl className="mb-8 w-full overflow-hidden text-left">
                <dt className="float-left clear-left w-[30%] text-sm leading-8 text-neutral-900">
                  スペース春
                </dt>
                <dd className="ml-[35%] text-sm leading-8">
                  <span className="text-xl text-neutral-700">¥2,200</span>
                  <span className="text-xs text-neutral-900">(税込)</span> /
                  時間
                </dd>
                <dt className="float-left clear-left w-[30%] text-sm leading-8 text-neutral-900">
                  スペース夏
                </dt>
                <dd className="ml-[35%] text-sm leading-8">
                  <span className="text-xl text-neutral-700">¥1,100</span>
                  <span className="text-xs text-neutral-900">(税込)</span> /
                  時間
                </dd>
                <dt className="float-left clear-left w-[30%] text-sm leading-8 text-neutral-900">
                  スペース秋
                </dt>
                <dd className="ml-[35%] text-sm leading-8">
                  <span className="text-xl text-neutral-700">¥1,100</span>
                  <span className="text-xs text-neutral-900">(税込)</span> /
                  時間
                </dd>
              </dl>
              <OutlinePrimaryLink
                href="/mypage/events/new?eventType=place"
                size="md"
                variant="filled">
                スペースをかりる
              </OutlinePrimaryLink>
            </div>
            <p className="text-left text-xs text-neutral-700">
              ※各スペースを組み合わせて利用することも可能です。
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* フロアガイド */}
    <section id="floor" className="border-t border-neutral-100 pb-20 pt-16">
      <div className="text-center">
        <h2 className="mb-10 inline-flex border-b-2 border-primary pb-1 text-base font-semibold tracking-[1.2px] text-primary">
          フロアガイド
        </h2>
      </div>
      <div className="mx-auto mb-8 max-w-[840px] px-4 text-center text-sm font-light text-neutral-900">
        <p>スペースを丸ごと貸し切ってイベントや会議をしよう！</p>
      </div>

      <div className="flex justify-center">
        <div className="mx-5 text-center">
          <div className="mx-auto mb-5 flex h-[22px] w-[42px] items-center justify-center rounded-full border border-gray-300 text-sm">
            2F
          </div>
          <img src="/assets/floormap-2f.png" alt="" />
        </div>
      </div>

      <div className="mt-[60px] px-4">
        <SwiperCarousel
          slidesPerView={1}
          spaceBetween={24}
          breakpoints={{
            640: {slidesPerView: 2, spaceBetween: 24},
            1024: {slidesPerView: 3, spaceBetween: 24},
          }}>
          {SPACE_CARDS.map((card) => (
            <div key={card.tag}>
              <img src={card.img} alt="" className="w-full object-cover" />
              <div className="pt-4 text-left">
                <div className="mb-3">
                  <span className="inline-block rounded-full bg-primary px-3 py-1 text-sm font-semibold text-white">
                    {card.tag}
                  </span>
                </div>
                <div className="text-sm font-light text-neutral-900">
                  {card.paragraphs.map((p, i) => (
                    <p key={i}>{p}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </SwiperCarousel>
      </div>
    </section>

    {/* 設備・サービス */}
    <section id="facility" className="border-t border-neutral-100 pb-20 pt-16">
      <div className="text-center">
        <h2 className="mb-10 inline-flex border-b-2 border-primary pb-1 text-base font-semibold tracking-[1.2px] text-primary">
          設備・サービス
        </h2>
      </div>

      <div className="mb-16 text-center">
        <div className="mx-auto mb-5 flex h-7 w-[83px] items-center justify-center rounded-full border border-gray-300 text-sm">
          無料
        </div>
        <p className="text-sm font-light text-neutral-900">
          電源、Wi-Fi、ホワイトボード、音響設備、プロジェクタ、A型看板、コート掛け
        </p>
        <p className="text-xs text-neutral-700">
          ※マイクは、スペース春またはスペース春併用でご利用頂けます。
        </p>
      </div>

      <div className="mb-16 text-center">
        <div className="mx-auto mb-5 flex h-7 w-[83px] items-center justify-center rounded-full border border-gray-300 text-sm">
          有料
        </div>

        <div className="mx-auto mb-7 flex flex-wrap justify-center">
          {FACILITIES.map((f) => (
            <div key={f.name} className="mx-11 w-40 text-center">
              <img src={f.img} alt="" className="mx-auto mb-3 max-w-[160px]" />
              <p className="mb-2 text-sm leading-tight text-neutral-900">
                {f.name}
              </p>
              <p className="text-xs leading-normal text-neutral-700">
                {f.description}
              </p>
            </div>
          ))}
        </div>

        <p className="text-xs text-neutral-700">
          ※有料サービスは完全予約制となっております。ご利用申し込み時にお問い合わせください。
        </p>
        <p className="text-xs text-neutral-700">
          また、料金につきましては申し込み後にお打ち合わせをさせて頂き確定いたします。
        </p>
      </div>
    </section>

    {/* アクセス */}
    <section id="access" className="border-t border-neutral-100 pb-20 pt-16">
      <div className="text-center">
        <h2 className="mb-10 inline-flex border-b-2 border-primary pb-1 text-base font-semibold tracking-[1.2px] text-primary">
          アクセス
        </h2>
      </div>
      <p className="text-center text-sm font-light text-neutral-900">
        〒723-0014 広島県三原市城町1-12-5 エムセックビル1〜2階
      </p>
      <p className="mb-6 text-center text-xs text-neutral-700">
        JR三原駅より徒歩5分。三原港より徒歩3分。
      </p>

      <div className="flex justify-center">
        <img src="/assets/access-01.png" alt="" className="m-5" />
        <img src="/assets/access-02.png" alt="" className="m-5" />
      </div>

      <div className="mt-8 text-center">
        <OutlinePrimaryLink
          href="https://goo.gl/maps/rQLAerziXgN2"
          size="md"
          target="_blank"
          rel="noreferrer">
          <span>Google Map へ</span>
        </OutlinePrimaryLink>
      </div>
    </section>
  </main>
);
